import { Fab } from "@mui/material";
import { Add } from '@mui/icons-material';
import React, { Component } from "react";
import ImageActionCreators from "../../controller/action/ImageActionCreators";
import ImageStore from '../../controller/store/ImageStore';

interface StateInterface {
    imagesUrl: string[]
}

const createState = () => {
    const images = ImageStore.images;

    return {
        'imageUrl': images
    };
}

export default class ImageContainer extends Component {

    public state: StateInterface

    private inputFileRef: React.RefObject<HTMLInputElement>

    constructor(props: any) {
        super(props);
        this.state = {
            imagesUrl: ImageStore.images
        }
        this.inputFileRef = React.createRef();
        this.onStateChange = this.onStateChange.bind(this);
        this.handleClickAddImageButton = this.handleClickAddImageButton.bind(this);
    }

    onStateChange() {
        this.setState(createState());
    }

    componentDidMount() {
        ImageStore.addChangeListener(this.onStateChange);
    }

    componentWillUnmount() {
        ImageStore.removeChangeListener(this.onStateChange);
    }

    private handleClickAddImageButton(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
        this.inputFileRef.current?.click();
    }

    private handleSelectImage(files: FileList|undefined|null) {
        if (files !== null && files !== undefined) {
            ImageActionCreators.addImageToBucket(files);
        }
    }

    render() {
        return(
            <div style={{ width: '100%', height: '100%' }}>
                <div style={{ textAlign: 'center' }}><h3>Mes Images :</h3></div>
                <div>
                    <div style={{ display: 'flex', width: '80%', marginLeft: '10%' }}>
                        {
                            this.state.imagesUrl.map((aUrl) => {
                                return(
                                    <div style={{ width: '200px', height: '200px', margin: '10px' }}>
                                        <img style={{ width: '100%', height: '100%' }}src={aUrl} alt="" onClick={(e) => {
                                            console.log(e);
                                        }}/>
                                    </div>
                                );
                            })
                        }
                    </div>
                    <div className="add_image" style={{ width: '10%', position: 'fixed', right: '20px', bottom: '40px'}}>
                        <Fab
                            color="primary" 
                            aria-label="add"
                            onClick={this.handleClickAddImageButton}
                        >
                            <Add/>
                        </Fab>
                        <input ref={this.inputFileRef} onChange={(_e) => {
                            this.handleSelectImage(this.inputFileRef.current?.files);
                        }} type="file" style={{display:'none'}} /> 
                    </div>
                </div>
            </div>
        );
    }
}